import { VStack } from '@adc/parallax-component-library';
import React from 'react';
import type { ColorTokens } from '@tamagui/web';

type ProgressBarProps = {
  progress: number; // Progress value between 0 and 100
  color?: ColorTokens; // Design system color token, defaults to primary blue
  testId?: string; // Optional test ID for testing
};

export function ProgressBar({
  progress,
  color = '$abbott.lightBlue.default',
  testId,
}: ProgressBarProps): React.JSX.Element {
  return (
    <VStack
      height={12}
      backgroundColor="$neutral.20"
      borderRadius={6}
      testID={testId}
    >
      <VStack
        width={`${progress}%`}
        backgroundColor={color}
        height={12}
        borderRadius={6}
      />
    </VStack>
  );
}
